import { render } from "./ExplainerCategory.vue?vue&type=template&id=5a2dfa56"
import script from "./ExplainerCategory.vue?vue&type=script&lang=js"
export * from "./ExplainerCategory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__